import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-complete-register-app',
  templateUrl: './complete-register-app.component.html',
  styleUrls: ['./complete-register-app.component.scss']
})
export class CompleteRegisterAppComponent implements OnInit {

  // 0: recibe givi, 1: invitación de comunidades aceptado manual, 2: invitación de comunidades aceptado automático
  @Input() typeMessage: number = 0;
  @Input() userLogin: string = '';
  @Input() communityName: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
